import { section } from '@/neon';

import carousel from '@/components/carousel';
import scrollIntoView from '@/lib/scrollIntoView';

const selectors = {
  carousel: '[data-carousel]',
  animatedSlides: '.animates',
};

section('blog-posts', {
  onLoad() {
    this.animatedSlides = this.container.querySelectorAll(
      selectors.animatedSlides
    );
    this.carouselContainer = this.container.querySelector(
      selectors.carouselContainer
    );

    if (this.animatedSlides.length > 1) {
      this.carousel = carousel(this.container);
    }

    if (this.animatedSlides.length) {
      this.scrollAnimation = scrollIntoView(
        this.container,
        this.animatedSlides
      );
    }
  },

  onUnload() {
    this.carousel && this.carousel.unload();

    if (this.animatedSlides.length) {
      this.scrollAnimation.unload();
    }
  },
});
